import { units } from './units';

const wizardOnlySignalUnits = [
  { category: 'Time', label: 'Seconds', value: 'seconds' },
  { category: 'Time', label: 'Minutes', value: 'minutes' },
  { category: 'Time', label: 'Hours', value: 'hours' },
];

const signalUnits = [
  ...units.map(({ category, id, name }) => ({
    category,
    label: `${category}: ${name}`,
    value: id,
  })),
  ...wizardOnlySignalUnits.map(({ category, label, value }) => ({
    category,
    label: `${category}: ${label}`,
    value,
  })),
];

const signalUnitOptions = signalUnits.map(({ label, value }) => ({
  enum: [value],
  title: label,
}));

const isValidCustomSignalUnit = (value) => value.trim().length > 0;

export { signalUnits, signalUnitOptions, isValidCustomSignalUnit };
